import { DemandesConge } from 'features/collaborateur/types';
import axiosInstance from 'utils/axiosInstance';
import {
  CongeType,
  DaysOffResponse,
  Decision,
  DemandeExportFilter,
  LeaveList,
  MainResponse,
  ReportRequest,
  ResponseStatsConge,
  Schedule,
  SelectUsers,
  TableFilter,
  WorkRegimeData,
} from '../types/leaveRequestType';
import { AxiosProgressEvent } from 'axios';
import { SoldeDetailRequest, SoldeDetailResponse } from '../types/soldeDetail';

export const getStatisticConge = async (): Promise<ResponseStatsConge> => {
  try {
    const { data } = await axiosInstance.get<ApiResponse<ResponseStatsConge>>(
      'api/demandeconge/GetCount',
    );
    return data.data;
  } catch (error) {
    console.error('Error fetching users demande conge:', error);
    throw error;
  }
};

export const GetConge = async (
  filters: TableFilter,
): Promise<DemandesConge> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<DemandesConge>>(
      'api/demandeconge/GetDemandes',
      filters,
    );
    return data.data;
  } catch (error) {
    console.error('Error fetching users collaborateur:', error);
    throw error;
  }
};

export const GetDetailsConge = async (
  id: number,
): Promise<ApiResponse<MainResponse>> => {
  try {
    const { data } = await axiosInstance.get<ApiResponse<MainResponse>>(
      `api/demandeconge/GetInfo/${id}`,
    );
    return data;
  } catch (error) {
    console.error('Error fetching users collaborateur:', error);
    throw error;
  }
};

export const acceptedConge = async (
  payload: Decision,
): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<null>>(
      'api/demandeconge/Accept',
      payload,
    );
    return data;
  } catch (error) {
    console.error('Error fetching users collaborateur:', error);
    throw error;
  }
};

export const rejectConge = async (
  payload: Decision,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/demandeconge/Reject',
    payload,
  );
  return data;
};

export const cancelConge = async (
  payload: Decision,
): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<null>>(
      'api/demandeconge/Cancel',
      payload,
    );
    return data;
  } catch (error) {
    console.error('Error fetching users collaborateur:', error);
    throw error;
  }
};

export const deleteConge = async (id: number): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.delete<ApiResponse<null>>(
      `api/demandeconge/Delete/${id}`,
    );
    return data;
  } catch (error) {
    console.error('Error fetching users collaborateur:', error);
    throw error;
  }
};

export const Getusers = async (): Promise<SelectUsers> => {
  try {
    const { data } = await axiosInstance.get<ApiResponse<SelectUsers>>(
      'api/collaborateur/list',
    );
    return data.data;
  } catch (error) {
    console.error('Error fetching users collaborateur:', error);
    throw error;
  }
};

export const GetLeaveUsers = async (): Promise<SelectUsers> => {
  const { data } = await axiosInstance.get<ApiResponse<SelectUsers>>(
    'api/collaborateur/listwithregime',
  );
  return data.data;
};

export const Gettypes = async (): Promise<LeaveList> => {
  try {
    const { data } = await axiosInstance.get<ApiResponse<LeaveList>>(
      'api/typeconge/GetTypesList',
    );
    return data.data;
  } catch (error) {
    console.error('Error fetching type conge:', error);
    throw error;
  }
};

export const GetNumberofDays = async (
  payload: Schedule,
): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<null>>(
      'api/solde/NumberofDays',
      payload,
    );
    return data;
  } catch (error) {
    console.error('Error fetching type conge:', error);
    throw error;
  }
};

export const GetHolidaySolde = async (
  payload: ReportRequest,
): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<null>>(
      'api/solde/GetHolidaySolde',
      payload,
    );
    return data;
  } catch (error) {
    console.error('Error fetching type conge:', error);
    throw error;
  }
};

export const GetDaysOff = async (
  payload: WorkRegimeData,
): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<null>>(
      'api/demandeconge/DaysOff',
      payload,
    );
    return data;
  } catch (error) {
    console.error('Error fetching type conge:', error);
    throw error;
  }
};

export const CreateConge = async (
  payload: FormData,
  onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
  signal: AbortSignal,
): Promise<ApiResponse<null>> => {
  try {
    const { data } = await axiosInstance.post<ApiResponse<null>>(
      'api/demandeconge/Create',
      payload,
      { onUploadProgress, signal },
    );
    return data;
  } catch (error) {
    console.error('Error fetching type conge:', error);
    throw error;
  }
};

export const GetTypeConge = async (): Promise<SelectOptionResponse[]> => {
  try {
    const { data } =
      await axiosInstance.get<ApiResponse<SelectOptionResponse[]>>(
        'api/typeconge/list',
      );
    return data.data;
  } catch (error) {
    console.error('Error fetching users typeconge:', error);
    throw error;
  }
};

// new

export const GettypesService = async (id: string): Promise<CongeType> => {
  const { data } = await axiosInstance.get<ApiResponse<CongeType>>(
    `/api/demandeconge/RegimeTypes/${id}`,
  );
  return data.data;
};

export const GetHolidaySoldeService = async (
  payload: ReportRequest,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/solde/GetHolidaySolde',
    payload,
  );
  return data;
};

export const CreateCongeService = async (
  payload: FormData,
  onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
  signal: AbortSignal,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/demandeconge/Create',
    payload,
    { onUploadProgress, signal },
  );
  return data;
};

export const EditCongeService = async (
  payload: FormData,
  onUploadProgress: (progressEvent: AxiosProgressEvent) => void,
  signal: AbortSignal,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/demandeconge/Edit',
    payload,
    { onUploadProgress, signal },
  );
  return data;
};
export const GetConditionCongeService = async (
  payload: WorkRegimeData,
): Promise<DaysOffResponse> => {
  const { data } = await axiosInstance.post<ApiResponse<DaysOffResponse>>(
    'api/demandeconge/DaysOff',
    payload,
  );
  return data.data;
};

export const GetNoticePeriodService = async (
  congeId: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.get<ApiResponse<null>>(
    `/api/demandeconge/NoticePeriod/${congeId}`,
  );
  return data;
};

export const GetNumberofDaysService = async (
  payload: Schedule,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/solde/NumberofDays',
    payload,
  );
  return data;
};

export const UserDailyWorkAverageService = async (
  userId: string,
  regimeId: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.get<ApiResponse<null>>(
    `/api/solde/UserDailyWorkAverage/${userId}/${regimeId}`,
  );
  return data;
};

export const getStatisticCongeService =
  async (): Promise<ResponseStatsConge> => {
    const { data } = await axiosInstance.get<ApiResponse<ResponseStatsConge>>(
      'api/demandeconge/GetCount',
    );
    return data.data;
  };

export const GetTypeCongeService = async (): Promise<
  ApiResponse<SelectItem[]>
> => {
  const { data } =
    await axiosInstance.get<ApiResponse<SelectItem[]>>('api/typeconge/list');
  return data;
};

export const GetdemandeCongeService = async (
  filters: TableFilter,
): Promise<DemandesConge> => {
  const { data } = await axiosInstance.post<ApiResponse<DemandesConge>>(
    'api/demandeconge/GetDemandes',
    filters,
  );
  return data.data;
};

export const ExportCongeService = async (
  filters: DemandeExportFilter,
): Promise<ArrayBuffer> => {
  const { data } = await axiosInstance.post<ArrayBuffer>(
    '/api/congee/ExportConge',
    filters,
    {
      responseType: 'arraybuffer',
    },
  );
  return data;
};

export const demandecongeDeleteFile = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.get<ApiResponse<null>>(
    `/api/demandeconge/DeleteFile/${id}`,
  );
  return data;
};

export const forceAcceptConge = async (
  id: number,
): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    'api/demandeconge/ForceAccept',
    JSON.stringify(id),
    { headers: { 'Content-Type': 'application/json' } },
  );
  return data;
};

// FIFO leave-balance breakdown (accrual cycles + allocations).
export const GetSoldeDetailService = async (
  payload: SoldeDetailRequest,
): Promise<SoldeDetailResponse> => {
  const { data } = await axiosInstance.post<SoldeDetailResponse>(
    'api/solde/GetSoldDetail',
    payload,
  );
  return data;
};

// FIFO rollout switch — SupportMintHR only (non-support callers get success:false).
export const GetUseFifoLeaveBalanceService = async (): Promise<
  ApiResponse<boolean>
> => {
  const { data } = await axiosInstance.get<ApiResponse<boolean>>(
    'api/solde/GetUseFifoLeaveBalance',
  );
  return data;
};

export const SetUseFifoLeaveBalanceService = async (
  enabled: boolean,
): Promise<ApiResponse<boolean>> => {
  const { data } = await axiosInstance.post<ApiResponse<boolean>>(
    'api/solde/SetUseFifoLeaveBalance',
    JSON.stringify(enabled),
    { headers: { 'Content-Type': 'application/json' } },
  );
  return data;
};
